import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EMPTY, forkJoin } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment.local';
import { FeatureToggle } from '../../models/feature-toggle.model';
import { BreadcrumbAndTitleService } from '../../services/breadcrumb-and-title/breadcrumb-and-title.service';
import { ExperimentalFeaturesService } from '../../services/experimental-features.service';
import { FeatureTogglesService } from '../../services/feature-toggles.service';
import { UserNotificationService } from '../../services/user-notification.service';

@Component({
    selector: 'ca-experimental-features',
    templateUrl: './experimental-features.component.html',
    styleUrls: ['./experimental-features.component.scss'],
})
export class ExperimentalFeaturesComponent implements OnInit {
    allFeatureToggles: FeatureToggle[];
    availableForUser: Map<string, boolean>;
    environment = environment;

    constructor(
        public experimentalFeaturesService: ExperimentalFeaturesService,
        private featureToggleService: FeatureTogglesService,
        private breadcrumbAndTitleService: BreadcrumbAndTitleService,
        private userNotificationService: UserNotificationService,
        private translateService: TranslateService,
    ) {}

    ngOnInit(): void {
        this.breadcrumbAndTitleService.setBreadcrumbAndTitle([
            {
                titleKey: 'EXPERIMENTAL_FEATURES.BROWSER_TITLE',
                route: '/experimental-features',
            },
        ]);
        this.loadAllFeatureToggles();
    }

    loadAllFeatureToggles(): void {
        this.userNotificationService.showSpinner();
        forkJoin([this.featureToggleService.getAllFeatureToggles$(), this.featureToggleService.getUserFeatureToggles$()])
            .pipe(
                tap((res: [FeatureToggle[], Map<string, boolean>]) => {
                    this.allFeatureToggles = res[0];
                    this.availableForUser = res[1];
                    this.userNotificationService.hideSpinner();
                }),
                catchError((err: unknown) => {
                    this.userNotificationService.hideSpinner();
                    const failedText = this.translateService.instant('FAILED_TO_FETCH_ALL') as string;
                    if (failedText.length > 0) {
                        this.userNotificationService.showError(failedText);
                    }

                    console.error('Failed loading feature all available toggles', err);
                    return EMPTY;
                }),
            )
            .subscribe();
    }
}
